import { CancelSurgicalScheduleRequest } from 'domain/usecases/cancel-surgical-schedule-request/cancel-surgical-schedule-request'
import { SurgicalScheduleRepository } from 'repository/interfaces/surgical-schedule-repository'

export class RemoteCancelSurgicalScheduleRequest
  implements CancelSurgicalScheduleRequest
{
  constructor(
    private readonly surgicalScheduleRepository: SurgicalScheduleRepository
  ) {}

  cancel(
    params: CancelSurgicalScheduleRequest.Params
  ): Promise<CancelSurgicalScheduleRequest.Model> {
    return this.surgicalScheduleRepository.cancelSurgicalScheduleRequest(params)
  }
}
